<div class="next-button">
    <button
        data-cy="next-button"
        siriusButton
        size="large"
        [buttonText]="text"
        [buttonType]="'primary'"
        (click)="submitEvent()"
        [disabled]="isDisabled"
        iconName="arrow_right"></button>
</div>
